import { type User } from 'firebase/auth'
import { writable } from 'svelte/store'

const isAuthenticated = writable<'tbd' | 'yes' | 'no'>('tbd')
const authUser = writable<User | null>(null)

export { isAuthenticated, authUser }
